export default "__VITE_ASSET__BzRqNhdZ__"